export const ADD_BUNDLE_DETAILS = "addbundledetails";
export const ADD_CURRICULUM = "addcurriculumdetails";
